import { QueryClient } from '@tanstack/react-query';

// In-memory only. We deliberately do NOT persist query results to
// localStorage / Capacitor Preferences: a cross-session cache replayed stale
// data on launch (e.g. hid brand-new store invitations) and, because the
// store was per-browser and never cleared on logout, leaked one account's
// data to the next account signing in on the same device.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
